import { AbilityBuilder, Ability } from "@casl/ability";
import ability from "./ability";

export const UpdateAbility = (userPermissions, customerCode) => {
  const { can, cannot, rules } = new AbilityBuilder(Ability);
  const permissions = userPermissions[customerCode];
  if (permissions.length > 0) {
    if (permissions.includes("*")) {
      can("manage", "all");
    } else {
      permissions.forEach((permit) => {
        const referenceIndex = permit.lastIndexOf(".");
        const action =
          permit.substring(referenceIndex + 1, permit.length) === "*"
            ? "manage"
            : permit.substring(referenceIndex + 1, permit.length);
        const subject = permit.substring(0, referenceIndex);
        can(action, subject);
      });
    }
  } else {
    can("manage", "nothing");
  }
  ability.update(rules);
};

export const CleanAbilities = () => {
  ability.update([]);
};
